var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnliked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28996 13.7295H2.56996C2.095 13.7295 1.70996 13.3445 1.70996 12.8695L1.70996 2.54949C1.70996 2.07453 2.095 1.68949 2.56996 1.68949H5.14996L5.14996 12.8695C5.14996 13.3445 4.76493 13.7295 4.28996 13.7295Z",
    fill: "#171A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4886 14.465C20.2429 14.5409 19.9872 14.5795 19.7301 14.5794L14.5701 14.5794L14.5701 17.1594C14.5701 20.4481 12.3435 21.4095 11.1662 21.4594C10.9324 21.4676 10.705 21.3818 10.535 21.2212C10.3655 21.0588 10.2698 20.8341 10.2701 20.5994L10.2701 16.6107L6.83008 12.4827L6.83008 1.67942L17.3479 1.67942C18.4828 1.67422 19.4864 2.41489 19.8161 3.5009L22.1974 11.2409C22.3984 11.8951 22.3313 12.6023 22.0108 13.2069C21.6904 13.8116 21.1428 14.2641 20.4886 14.465Z",
    fill: "#171A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnliked);
export default __webpack_public_path__ + "static/media/unliked.f052c24eefec473e5f2dfd86fbde0657.svg";
export { ForwardRef as ReactComponent };